export function convertDestinationURLFromVueApp(destination: unknown): string {
  if (typeof destination !== "string")
    throw new Error("destination provided was not a string");
  return destination.replace(/_/g, "/");
}
